import { styled } from '@mui/material';

export const IconSvg = styled('svg')({});
